import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.bindElement ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    style: {
      "display": "inline-block"
    },
    src: $data.imgUrl
  }, null, 8, _hoisted_1)) : _createCommentVNode("", true);
}